










import { Vue, Component } from 'vue-property-decorator';
import BajasComercialesBase from './BajasComercialesBase.vue';

@Component({ components: { BajasComercialesBase } })
export default class BajasComercialesPantalla extends Vue {}
